import { store } from "common/store";
import { request } from "common/components/request";
import { retry } from "common/helpers/retry";
import { captureException } from "extensions/sentry";

import { actions } from "common/reducers/components";

export const FETCH_TABLE_CONFIGS = () => {
    store.dispatch({
        type: "FETCH_TABLE_CONFIGS"
    });
    return retry(() => request("/merchant/:merchant_ref/user/ui_table_config"))
        .then((payload) => store.dispatch(actions.SET_TABLE_CONFIGS(
            payload
        ))).catch((error) => {
            captureException(error);
        });
};

export const FETCH_TABLE_CONFIG = ({ params } = {}) => request("/merchant/:merchant_ref/user/ui_table_config", {
    data: { ...params }
});

// eslint-disable-next-line object-curly-newline
export const SAVE_TABLE_CONFIG = ({ _id, level, type, data, section, component } = {}) => request("/merchant/:merchant_ref/user/ui_table_config", {
    method: _id && level === "user" ? "PUT" : "POST",
    data: {
        _id,
        section,
        type,
        data,
        component
    }
});

export const UPDATE_STORED_CONFIG = (payload) => store.dispatch(actions.UPDATE_STORED_CONFIG(payload));
